import MetricsTabsContextProvider from './contexts/MetricsTabsContext';
import RangeTabsContextProvider from './contexts/RangeTabsContext';
import Dashboard from './Dashboard';

const DashboardContainer = () => (
  <RangeTabsContextProvider>
    <MetricsTabsContextProvider>
      <Dashboard />
    </MetricsTabsContextProvider>
  </RangeTabsContextProvider>
);

export default DashboardContainer;
